import React, { useEffect, useState } from "react"
import { RateStar, RateStar1 } from "../../../Svgs/Svg"
import uploaderImg from "../../../asst/ProductImageUploader.svg"
import { isMobile } from "react-device-detect"

const NewRatePopup = (props) => {
  let {
    settings,
    onReviewSelect,
    data,
    setStarCheck,
    starCheck,
    ordersData,
    orderProductIndex,
    brandSettingsData,
    collectSettings,
    xToken,
    newDiscount,
    storeCurrency,
    getCurrencySymbol,
    checkAccessed,
    isOnSite
  } = props

  const selectReview = (e) => {
    onReviewSelect(e)
    setTimeout(() => {
      window.scrollTo({ top: 0 })
    }, 250)
  }


  const [hoverStarValue, setHoverStarValue] = useState(null)

  console.log(hoverStarValue, "====>>>hoverStarValue")
  // console.log(ordersData[0]?.products, "==>ordersData")
  useEffect(() => {
    if (data.review > 0) {
      setStarCheck(false)
    }
  }, [data])

  const getDiscountText = () => {
    if (collectSettings?.discounts?.offerDiscount === "reviewRequest" && isOnSite === true) {
      return `Share ${collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "Photos/Videos" : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "Videos" : "Photos"} & Help Others`
    }
    const photoDiscount = collectSettings?.discounts?.discountForPhotoReview;
    const videoDiscount = collectSettings?.discounts?.discountForVideoReview;
    const bothEnabled = collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true";

    // Check if both discounts are the same value and type
    const sameDiscount = bothEnabled &&
      photoDiscount?.value === videoDiscount?.value &&
      photoDiscount?.typeOfDiscount === videoDiscount?.typeOfDiscount;

    if (sameDiscount) {
      const discountValue = photoDiscount?.value;
      const discountSymbol = photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? "";
      return `Share Photo/Video & Get ${discountValue}${discountSymbol} Off `;
    }

    return `Share ${bothEnabled ? `Photos for ${photoDiscount?.value
      }${photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""} & Videos for ${videoDiscount?.value
      }${videoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}` : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? `Videos for ${videoDiscount?.value
        }${videoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}` : `Photos for ${photoDiscount?.value
        }${photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}`} Off `
  }

  return (
    <div>

      <div className="rcf-rating-main-container">
        {/* Main heading */}
        <div
          className="rcf-rating-heading"
          style={{
            color: settings?.fontColor ?? "#000",
          }}
        >
          {collectSettings?.discounts
            ?.typeOfDiscount === "no" ||
            !collectSettings?.discounts
              ?.typeOfDiscount || (collectSettings?.discounts
                ?.typeOfDiscount && checkAccessed("discountCode") === false)
            ? `Share ${collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "Photos/Videos" : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "Videos" : "Photos"} & Help Others`
            :
            getDiscountText()}
        </div>
        {ordersData[0]?.products?.length > 1 ? (
          <span className="product-count">
            Product {orderProductIndex} Of {ordersData[0]?.products.length}
          </span>
        ) : (
          ""
        )}
        {/* Product name and rating section */}
        <div className="rcf-rating-content">
          {/* Product name */}
          <div className="rcf-rating-content-img d-flex align-items-center gap-4">
            {ordersData ? (
              <img
                className="uploaderImg-new-rcf"
                src={
                  ordersData[0]?.products[orderProductIndex - 1]?.image ??
                  uploaderImg
                }
                alt="product like"
              />
            ) : (
              <img
                className="uploaderImg-new-rcf"
                src={data?.item?.image ?? uploaderImg}
                alt="product one"
              />
            )}
            {ordersData ? (
              <span
                className="rcf-pruduct-name"
                style={{
                  color: settings?.fontColor ?? "#000",
                }}
              >
                {ordersData[0]?.products[orderProductIndex - 1]?.title || "{Product_name}"}
              </span>
            ) : (
              <span
                className="rcf-pruduct-name"
                style={{
                  color: settings?.fontColor ?? "#000",
                }}
              >

                {data?.item?.title}
              </span>
            )}
          </div>
          {/* Star selection */}
          <div
            className="rate-popup-container new-rcf-rating"
            style={{
              "--star-hover-color": brandSettingsData?.generalAppearance?.starColor ?? "#FFC803",
              "--rate-background": settings?.backgroundColor ?? "#fff",
              "--rate-tooltip": settings?.toolTipColor ?? "#000",
            }}
          >
            <div className="rate-popup new-rcf-rate">
              <div className="popup-content new-rcf-rate">
                {isMobile ? (
                  <div className="rate-btns new-rcf-rate">
                    <button
                      onClick={() => {
                        selectReview(1)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 1 || data?.review > 0 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(1)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar1
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 0
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }

                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(2)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 2 || data?.review > 1 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(2)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar1
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 1
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(3)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 3 || data?.review > 2 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(3)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar1
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 2
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(4)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 4 || data?.review > 3 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(4)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar1
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 3
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(5)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 5 || data?.review > 4 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(5)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar1
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 4
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <p className="rate-text" style={{ color: settings?.fontColor ?? '#000' }}>
                      {data?.review == 5 ? "Excellent" : data?.review == 4 ? "Good" : data?.review == 3 ? "Average" : data?.review == 2 ? "Poor" : data?.review == 1 ? "Very Poor" : ""}
                    </p>
                  </div>
                ) : (
                  <div className="new-rcf-rate-star">
                    <button
                      onClick={() => {
                        selectReview(1)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 1 || data?.review > 0 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(1)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 0
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }

                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(2)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 2 || data?.review > 1 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(2)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 1
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(3)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 3 || data?.review > 2 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(3)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 2
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(4)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 4 || data?.review > 3 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(4)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 3
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <button
                      onClick={() => {
                        selectReview(5)
                        setHoverStarValue(null)
                      }}
                      className={`star-active-check ${hoverStarValue >= 5 || data?.review > 4 ? "active" : ""
                        }`}
                      onMouseEnter={() => {
                        setHoverStarValue(5)
                      }}
                      onMouseLeave={() => {
                        setHoverStarValue(null)
                      }}
                    >
                      <RateStar
                        hoverStarValue={hoverStarValue}
                        color={
                          data?.review > 4
                            ? brandSettingsData?.generalAppearance?.starColor ?? "#FFC803"
                            : settings?.emptyStarColor ?? "#e1dfdf"
                        }
                      />
                    </button>
                    <p className="rate-text" style={{ color: settings?.fontColor ?? '#000' }}>
                      {data?.review == 5 ? "Excellent" : data?.review == 4 ? "Good" : data?.review == 3 ? "Average" : data?.review == 2 ? "Poor" : data?.review == 1 ? "Very Poor" : ""}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <p className="error-description" style={{ color: "red" }}>
              {starCheck && "Select required field"}
            </p>
          </div>
        </div>
      </div>
      {/* <p className="required-rating-fields">* Required fields</p> */}
    </div>
  )
}

export default NewRatePopup
